import {AfterViewInit, Component, EventEmitter, Input, Output} from '@angular/core';
import { InfluencerCampaignPost } from '../../../../../models/influencer-campaign';
import { Router } from '../../../../../../node_modules/@angular/router';
import {CacheService} from '../../../../services/cache/cache.service';
import {PdfExportService} from '../../../../services/export-pdf/pdf-export.service';

@Component({
  selector: 'campaign-influencer-posts',
  templateUrl: './campaign-influencer-posts.component.html',
  styleUrls: ['./campaign-influencer-posts.component.scss']
})
export class CampaignInfluencerPostsComponent implements AfterViewInit {
  static COMPONENT_NAME = 'CampaignInfluencerPostsComponent';
  @Input() posts: InfluencerCampaignPost[];
  @Input() influencerId: number;
  @Input() originalFromPath: string;
  @Input() headerText: string;
  @Input() campaignInfluencerId: number;
  @Input() readonly = false;
  @Input() showHeader = true;
  // Use to determine position of page in PDF
  @Input() pageIndex: number;

  @Output() selectPost: EventEmitter<any> = new EventEmitter();

  constructor(private router: Router, private cacheService: CacheService, private pdfService: PdfExportService) { }

  ngAfterViewInit() {
    if (this.pageIndex >= 0) {
      const reportName = CampaignInfluencerPostsComponent.COMPONENT_NAME + this.pageIndex;
      if (this.posts.length === 0) {
        this.pdfService.incrementNumberReportReady(reportName);
        return;
      }

      this.pdfService.imagedLoadedTrigger.subscribe(data => {
        if (data.component === reportName && data.currentCounter === this.posts.length) {
          this.pdfService.incrementNumberReportReady(reportName);
        }
      });
    }
  }

  onLoadedImage() {
    if (this.pageIndex >= 0) {
      this.pdfService.updateNumberImageLoaded(CampaignInfluencerPostsComponent.COMPONENT_NAME + this.pageIndex);
    }
  }

  goToPost(fullUrl: string, relativePath: string, urlHash: string) {
    if (this.readonly) {
      return this.router.navigate(['dashboard', 'post', urlHash]);
    }
    this.cacheService.disableCacheRemoving();
    const influencerId = this.influencerId;
    const originalPathParams = this.originalFromPath && this.campaignInfluencerId ? `?from_path=${this.originalFromPath}&campaignInfluencerId=${this.campaignInfluencerId}` : '';
    this.router.navigate(['post'], {queryParams: {influencerId, urlHash, fullUrl, relativePath, from_path: `/influencer/${this.influencerId}/campaign${originalPathParams}`, }});
  }

  onSelectPost(post: InfluencerCampaignPost) {
    this.selectPost.emit({
      urlHash: post.urlHash,
      channelId: post.channelId
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-campaign-activity/campaign-influencer-posts/campaign-influencer-posts.component.ts